export default async function CascadeTopPlanApi(
  cascadeFrom,
  title,
  description,
  unitId,
  target,
  targetDate,
  assignTo,
  positionId,
  attributes
) {
  let res = "";
  try {
    const body = {
      cascadeFrom: cascadeFrom,
      title: title,
      description: description,
      unitId: unitId,
      target: target,
      targetDate: targetDate,
      assignTo: assignTo,
      positionId: positionId,
      attributes: attributes,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/cascade-top-plans`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
        console.log(response);
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
